import ApiService from "../services/api";
import { UserEvent } from "../models/userEvent";

export interface FetchUserEventsParams {
  page?: number;
  limit?: number;
  startDate: Date;
  endDate: Date;
}

export const fetchUserEvents = async (userId: string, params: FetchUserEventsParams): Promise<UserEvent[]> => {
  const apiService = new ApiService();

  const response = await apiService.get<any>(`/backoffice/users/${userId}/events`, {
    params: {
      page: params.page ?? 0,
      limit: params.limit ?? 50,
      startDate: params.startDate.toISOString(),
      endDate: params.endDate.toISOString(),
    },
  });
  if (response.status !== 200) throw new Error("Error fetching user events");

  const items: any[] = Array.isArray(response.data) ? response.data : [];

  return items.map((event: any) => ({
    eventType: event.eventType ?? '',
    createdAt: event.createdAt ? new Date(event.createdAt) : undefined,
  }));
};
